import { render, staticRenderFns } from "./EmptyCallView.vue?vue&type=template&id=04e422b3&scoped=true"
import script from "./EmptyCallView.vue?vue&type=script&lang=js"
export * from "./EmptyCallView.vue?vue&type=script&lang=js"
import style0 from "./EmptyCallView.vue?vue&type=style&index=0&id=04e422b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e422b3",
  null
  
)

export default component.exports